const BoutiqueImagesList = () => import('Views/boutiqueImages/boutique-images-list-new-ui');
const BoutiqueImagesDetail = () => import('Views/boutiqueImages/boutique-images-detail-new-ui');

export default[
  { path: '/boutique-images-list', component: BoutiqueImagesList },
  { path: '/boutique-images-detail/:id', component: BoutiqueImagesDetail },
];



// WEBPACK FOOTER //
// ./src/router/boutiqueImages.js